import React from 'react';
import SocialSecurityCalculator from '@components/pages/calculators/social-security-calculator';

const SocialSecurityRetirementBenefitsPage = () => <SocialSecurityCalculator />;

export default SocialSecurityRetirementBenefitsPage;
